import { exists } from '@aboutyou/legacy-shared/src/utils/exists'
import { RecoSectionContent } from '@aboutyou/legacy-tracking-sdk'
import { useTranslation } from 'helpers/hooks/useTranslation'
import { cdnImageUrl } from 'helpers/image'
import { useRouter } from 'helpers/navigation'
import { RecoGridSectionTrackingContextProvider } from 'helpers/tracking/SectionTrackingContext'
import BrandPromotionTracker from 'helpers/tracking/trackerComponents/BrandPromotionTracker'
import React, { FC } from 'react'
import { useService } from 'services/utils/context'
import styled from 'styled-components'
import BrandLogoChip from 'uiComponents/atoms/Chip/BrandLogoChip'
import {
  backgroundColorInactive,
  complementaryColor,
} from 'uiComponents/constants/colors'

const Grid = styled.section`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  position: relative;
  width: calc(66% - 80px);
  gap: 4px;
  align-items: stretch;
`

const BrandLogoWrapper = styled.div<{ $count: number }>`
  flex: 1 1 calc(33% - 4px);
  min-width: 150px;
`

const BrandLogo = styled(BrandLogoChip)`
  max-width: 100%;
  width: 100%;
  height: 100%;
  background-color: ${backgroundColorInactive};

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    /* add your IE10-IE11 css here - https://stackoverflow.com/questions/18907131/detecting-ie11-using-css-capability-feature-detection/35063378#35063378 */
    background-color: ${complementaryColor};
  }

  box-shadow: none;
  border-radius: 0;
  padding: 30px;
`

const BrandGrid: FC<{ brandIds: string[] }> = ({ brandIds }) => {
  const { t } = useTranslation()
  const { navigateClient } = useRouter()
  const service = useService()

  const brands = brandIds
    .map(brandId => service.brands.getByBrandId(brandId))
    .filter(exists)

  return (
    <RecoGridSectionTrackingContextProvider
      headline={'Premium Brands'}
      recoType={RecoSectionContent.topBrands}
    >
      <Grid>
        {brands.map(brand => {
          const logoSrc =
            brand.logoImageHash &&
            cdnImageUrl(brand.logoImageHash, {
              trim: 1,
              height: 100,
              width: 300,
            })

          if (!logoSrc) {
            return null
          }

          return (
            <BrandLogoWrapper key={brand.id} $count={brands.length}>
              <BrandPromotionTracker brand={brand}>
                <BrandLogo
                  key={brand.id}
                  dataTestId={`BrandLogo_${brand.name}`}
                  active={true}
                  logoSrc={logoSrc}
                  fallBackText={brand.name}
                  onClick={navigateClient(brand.url)}
                  href={brand.url}
                  isLink
                  alt={t('{{brandName}} Logo', { brandName: brand.name })}
                  hideBrandName
                />
              </BrandPromotionTracker>
            </BrandLogoWrapper>
          )
        })}
      </Grid>
    </RecoGridSectionTrackingContextProvider>
  )
}

export default BrandGrid
